import { render, staticRenderFns } from "./PrizeCarousel.vue?vue&type=template&id=b4d8acb0&scoped=true"
import script from "./PrizeCarousel.vue?vue&type=script&lang=js"
export * from "./PrizeCarousel.vue?vue&type=script&lang=js"
import style0 from "./PrizeCarousel.vue?vue&type=style&index=0&id=b4d8acb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8acb0",
  null
  
)

export default component.exports